<template>
  <FormControl :label="label" :required="required" :disabled="disabled" @disabled="onSetDisabled">
    <template slot-scope="slotProps">
      <div v-for="option in options" v-bind:key="option.value" class="form-check form-check-inline">
        <input
          ref="input"
          class="form-check-input"
          @change="onChange"
          :name="name"
          v-model="model[name]"
          type="radio"
          :value="option.value"
          :id="name + '-' + option.value"
          :disabled="getIsDisabled()"
          :class="{ 'is-invalid': slotProps.hasError }"
        />
        <label
          class="form-check-label"
          @keydown.prevent.space="onSpace(option)"
          tabindex="0"
          :for="name + '-' + option.value"
        >
          <span></span>
          {{ option.text }}
        </label>
      </div>
    </template>
  </FormControl>
</template>

<script>
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";

export default {
  name: "radio-group",
  props: ["required", "label", "model", "name", "options", "disabled"],
  components: {
    FormControl
  },
  mixins: [formControlMixin],
  methods: {
    onChange() {
      const value = this.model[this.name];

      this.$refs.input.forEach(item => {
        item.checked = item.value == value;
      });

      this.$emit("change", value);
    },
    onSpace(option) {
      if (!this.getIsDisabled()) {
        this.model[this.name] = option.value;
        this.onChange();
        this.$forceUpdate();
      }
    }
  }
};
</script>
